import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-thread-popup',
  templateUrl: './add-thread-popup.component.html',
  styleUrls: ['./add-thread-popup.component.scss']
})
export class AddThreadPopupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
